import { createFeatureSelector, createSelector } from '@ngrx/store'

import {
  ReusableFunctionLanguage,
  getAppSanitizedName,
  getFullFunctionName,
} from '@flowx/designer/modules/reusable-resources/reusable-functions/models/reusable-function.entity'

import {
  ReusableFunctionsState,
  reusableFunctionsFeatureKey,
} from '../reducers/reusable-functions.reducer'

export const selectFeature = createFeatureSelector<ReusableFunctionsState>(
  reusableFunctionsFeatureKey
)

export const selectAllReusableFunctions = createSelector(
  selectFeature,
  (state: ReusableFunctionsState) => state.reusableFunctions
)

export const reusableFunctionsWithAppNameMap = createSelector(
  selectAllReusableFunctions,
  (reusableFunctions) =>
    reusableFunctions.reduce((acc, rf) => {
      const sanitizedAppName = getAppSanitizedName(rf.manifestInfo.appName)
      const fullFunctionName = getFullFunctionName(rf)
      acc[fullFunctionName] = {
        ...rf,
        manifestInfo: { ...rf.manifestInfo, appName: sanitizedAppName },
      }
      return acc
    }, {})
)

export const selectJavascriptReusableFunctions = createSelector(
  selectAllReusableFunctions,
  (reusableFunctions) =>
    reusableFunctions.filter((rf) => rf.language === ReusableFunctionLanguage.JAVASCRIPT)
)
